import React from 'react'
import _sortBy from 'lodash/sortBy'
import _uniqBy from 'lodash/uniqBy'
import InlineSVG from 'react-inlinesvg'

import './css/Scores.css'
import trophy from './images/trophy.svg'
export default (props) => {

  function displayScores(day) {
    let scores = _sortBy(_uniqBy(props.scores, 'id'), ['score']).reverse()
    const renderTrophy = index => {
      if(index < 3){
        return <div className="trophyWrap animated tada"><InlineSVG src={trophy} /></div>
      } else {
        return `${index+1}.`
      }
    }

    return scores.map((score, index) => {
      if(score.day !== day) return false
      return <div key={score.id} className="Score is-flex">
        <div className="column ScoreNumber">{renderTrophy(index)}</div>
        <div className="column">{score.name}</div>
        <div className="column">{score.organisation}</div>
        <div className="column ScoreResult">{score.score}</div>
      </div>
    })
  }

  return (
    <div className="Scores columns fluid-container">
      <div className="ScoresWrap animated fadeIn">
        <div className="ScoreCol column">
          <h4 className="ScoreColTitle">Day 1</h4>
          <div className="ScoreList">
            { displayScores(0) }
          </div>
        </div>
        <div className="ScoreCol column">
          <h4 className="ScoreColTitle">Day 2</h4>
          <div className="ScoreList">
            { displayScores(1) }
          </div>
        </div>
        <div className="ScoreCol column">
          <h4 className="ScoreColTitle">Day 3</h4>
          <div className="ScoreList">
            { displayScores(2) }
          </div>
        </div>
      </div>
    </div>
  )
}



/** WEBPACK FOOTER **
 ** ./src/Scores.js
 **/